var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.857,
    y1: 0.173,
    x2: 0.219,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 20,
    ry: 20.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,39A19.5,19.5,0,0,1,5.711,5.711,19.5,19.5,0,0,1,33.289,33.289,19.372,19.372,0,0,1,19.5,39Zm.407-11.419c.077,0,.143.08.2.238v3.131c.42,1.582,1.39,1.818,1.931,1.818a1.427,1.427,0,0,0,.306-.029,1.886,1.886,0,0,1-.895-1.342V27.819c.04-.264.1-.4.176-.4.131,0,.27.394.272.4V30.5a1.874,1.874,0,0,0,.447,1.342,1.782,1.782,0,0,0,1.281.449h.061c.341-.016.533-.081.57-.193s-.12-.253-.122-.255a1.982,1.982,0,0,1-.895-.894V26.925c.044-1.679-.885-1.788-.895-1.789H19.895a10.131,10.131,0,0,0,6.156-1.962A6,6,0,0,0,28.6,18.428a5.925,5.925,0,0,0-1.923-4.249c.456-1.275.2-3.286-.313-3.8a.4.4,0,0,0-.261-.083c-.742,0-2.285,1.309-2.914,1.872a11.357,11.357,0,0,0-3.309-.492,10.646,10.646,0,0,0-3.668.626c-1.478-1.3-2.488-1.966-3.005-1.966a.37.37,0,0,0-.259.088c-.643.6-.746,2.981-.179,4.115a5.715,5.715,0,0,0-1.61,3.891,6,6,0,0,0,2.549,4.746,10.108,10.108,0,0,0,6.005,1.961H17.419c-.008,0-.85.106-.895,1.61v-.268l0,0a2.292,2.292,0,0,1-1.029.23c-.856,0-2.148-.428-3.439-2.469a1.294,1.294,0,0,0-.782-.33c-.393,0-.732.261-1.006.775l0,0a1.282,1.282,0,0,1,.652-.231c.337,0,.568.23.685.683a5.734,5.734,0,0,0,2.236,3.131,4.1,4.1,0,0,0,.958.15c.766.066,1.635.141,1.725.744v1.789a1.979,1.979,0,0,1-.894.894s-.162.134-.122.255.228.177.569.193h.061a1.782,1.782,0,0,0,1.281-.449,1.874,1.874,0,0,0,.448-1.342V27.819c.015-.041.146-.4.272-.4.077,0,.136.134.175.4V31.4a1.885,1.885,0,0,1-.895,1.342,1.424,1.424,0,0,0,.306.029c.541,0,1.511-.236,1.931-1.818V27.819C19.668,27.794,19.783,27.581,19.907,27.581Z",
    transform: "translate(4 4)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.ab52c42b6b1bc9c80e7fbf4a8cbcaa35.svg";
export { ForwardRef as ReactComponent };